import React, {Component} from "react";
import PropTypes from "prop-types";
import {removeHistory} from "../../services/HistoryServices";
import {broadcastTopic} from "../../services/EventServices";
import {REQUEST_SEARCH_TRADE_MARK} from "../../constants/EventConstants";

class HistoryItem extends Component {
    render() {
        const {history} = this.props;

        return (
            <div className="HistoryItem">
                <span
                    onClick={this._handleClickText}
                    className="Text">{history.text}</span>
                <span onClick={this._handleClickRemove} className="Close text-danger">×</span>
            </div>
        );
    }

    _handleClickText = (e) => {
        e.preventDefault();
        const {history} = this.props;

        broadcastTopic(REQUEST_SEARCH_TRADE_MARK, history.text);
    };

    _handleClickRemove = (e) => {
        e.preventDefault();

        const {history} = this.props;
        removeHistory(history.id);
    };
}

HistoryItem.propTypes = {
    history: PropTypes.object
};

export default HistoryItem;


// WEBPACK FOOTER //
// ./src/app/home/HistoryItem.js